import * as React from "react";
import { useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import { useAppSelector, useAppDispatch } from "../store/index";
import { RootState } from "../reducers/index";
import { composePathRoot } from "../api/utility";
import { selectCurrentPoi, showResults, selectMapDisplayMode } from "../reducers/poi";
import * as MapDisplayMode from "../constants/mapdisplaymode";
import { IMapOptions } from "../interfaces/mapoptions";

const Breadcrumb = () => {
    const mapoptions = useAppSelector<IMapOptions>((x: RootState) => x.mapoptions);
    const mapDisplayMode = useAppSelector<number>(selectMapDisplayMode);
    const poiData = useAppSelector(selectCurrentPoi);
    const { adr1, adr2, poiname, travel } = useParams();

    // memo this since basically it never changes.
    const homePage = useMemo(() => "/?a=" + encodeURIComponent(mapoptions.address1) +
        "&b=" + encodeURIComponent(mapoptions.address2) +
        "&poi=" + encodeURIComponent(mapoptions.poi) +
        "&tm=" + encodeURIComponent(mapoptions.travelMode), [mapoptions]);

    const linkSearch = <li className="breadcrumb-item"><a href={homePage}>Search</a></li>;

    let linkResults: JSX.Element;
    if (mapDisplayMode === MapDisplayMode.RESULTS) {
        linkResults = <li className="breadcrumb-item active">Results</li>;
    } else {
        const rooturl = composePathRoot(adr1, adr2, poiname, travel, mapoptions.code);
        linkResults = <li className="breadcrumb-item"><Link to={rooturl} >Results</Link></li>;
    }

    let linkPoi: JSX.Element;
    if (mapDisplayMode === MapDisplayMode.POI) {
        if (poiData) {
            const result = poiData.result;
            linkPoi = <li className="breadcrumb-item poi active">{result.name}</li>;
        }
    }

    return (<nav aria-label="breadcrumb"><ol className="breadcrumb" >{linkSearch} {linkResults} {linkPoi}</ol></nav>);
}

export default Breadcrumb;
